export class Meses {

	public Janeiro = 1;
	public Fevereiro = 2;
	public Marco = 3;
	public Abril = 4;
	public Maio = 5;
	public Junho = 6;
	public Julho = 7;
	public Agosto = 8;
	public Setembro = 9;
	public Outubro = 10;
	public Novembro = 11;
	public Dezembro = 12;

	getArray() {
		return [
			this.Janeiro,
			this.Fevereiro,
			this.Marco,
			this.Abril,
			this.Maio,
			this.Junho,
			this.Julho,
			this.Agosto,
			this.Setembro,
			this.Outubro,
			this.Novembro,
			this.Dezembro
		];
	}

	getDescricao(layout: number) {
		layout = Number(layout);
		switch (layout) {
			case 1: return "Janeiro";
			case 2: return "Fevereiro";
			case 3: return "Março";
			case 4: return "Abril";
			case 5: return "Maio";
			case 6: return "Junho";
			case 7: return "Julho";
			case 8: return "Agosto";
			case 9: return "Setembro";
			case 10: return "Outubro";
			case 11: return "Novembro";
			case 12: return "Dezembro";
			default: return "N/D";
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/models/meses.ts